import {
  useState,
  useLayoutEffect
} from "react";
import axios from './axios';
import * as API from './api';

// Get Current Window Size
export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

// Add Comma to number
export const numberWithCommas = (x, decimal = null) => {
  var valve = decimal ? x.toFixed(decimal) : x.toString()
  return valve.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// Group array by key
export const groupBy = (list, key) => {
  return list.reduce((acc, obj) => {
    let group_item = obj[key]

    if (acc.some(item => item.name === group_item) !== true) {
      acc.push({
        name: group_item,
        records: []
      })
    }

    acc = acc.map(item => {
      if (item.name === group_item) {
        item.records.push(obj)
      }
      return item
    })

    return acc
  }, [])
}

export const date_range = (start_date, end_date) => {
  var dates = []
  while (start_date <= end_date) {
    dates.push(start_date)
    start_date = start_date.clone().add(1, 'days')
  }
  return dates
}

export const getLocalStorage = (key) => {
  return localStorage.getItem(key);
}

export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, value);
}

export const removeLocalStorage = (key) => {
  localStorage.removeItem(key);
}

export const getAccessToken = () => {
  return getLocalStorage('access_token');
}

export const setAccessToken = (value) => {
  setLocalStorage('access_token', value);
}

export const removeAccessToken = () => {
  localStorage.removeItem('access_token');
}

export const getRefreshToken = () => {
  return getLocalStorage('refresh_token');
}

export const setRefreshToken = (value) => {
  if(value){
    setLocalStorage('refresh_token', value);
  }
}

export const removeRefreshToken = () => {
  localStorage.removeItem('refresh_token');
}

export const getAuthorizationHeader = () => {
  return { Authorization: `Bearer ${getAccessToken()}` }
}

export const removeUserData = () => {
  removeAccessToken();
  removeRefreshToken();
  removeLocalStorage('user');
  //removeLocalStorage('forgetPassword');
}

export const logOutEvent = async () => {

  const body = {
    access: getAccessToken()
  }

  const refresh_token = getRefreshToken();
  if(refresh_token){
    body.refresh = refresh_token();
  }

  axios.post(API.LOGOUT_API, body)
  .then((res) => {
    console.log(res);
  })
  .catch((err)=>{
    window.alert(err);
  })
  .finally((data)=>{
    removeUserData();
  })
}

export const updateRefreshToken = (eventHandles) => {
  const body = {
    refresh: getRefreshToken()
  }
  axios.post(API.REFRESH_TOKEN_API, body)
  .then((result) => {
    setAccessToken(result.data.access);
    setRefreshToken(result.data.refresh);
    eventHandles();
  })
  .catch((error) => {
    if (window.confirm(error.response.data.detail)) {
      logOutEvent();
    }
  })
}

export const isApi401Error = (error) => {
  return error.response && error.response.status === 401
}

